import script from "./ChatAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./ChatAnalysis.vue?vue&type=style&index=0&id=324d7b22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324d7b22"]])

export default __exports__